import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import routes from '../../config/routes';
import AuthChecker from '../auth/AuthChecker';
import Layout from '../utils/Layout';
import Loader from './Loader';

const Routing = () => {
  return (
    <Routes>
      {routes.map((route, index) => {
        return (
          <Route
            key={index}
            path={route.path}
            element={
              route.protected ? (
                <AuthChecker requiredPermission={route.requiredPermission}>
                  <Layout>
                    <Suspense fallback={<Loader />}>
                      <title>{route.name}</title>
                      <route.component />
                    </Suspense>
                  </Layout>
                </AuthChecker>
              ) : (
                <Suspense fallback={<Loader />}>
                  <route.component />
                </Suspense>
              )
            }
          />
        );
      })}
    </Routes>
  );
};

export default Routing;
